var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "53EFF7F0-6096-456D-BF0B-0673D3B46D7A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-727.000000, -516.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email-Button",
    transform: "translate(727.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("text", {
    id: "Name-Surname-Copy",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 9,
    fill: "#909090"
  }, "Name Surname")), /*#__PURE__*/React.createElement("text", {
    id: "email@mail.com",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5.5,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 17,
    fill: "#000000"
  }, "email@mail.com")), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(111.333333, 3.666667)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D8D8D8",
    cx: 6.66666667,
    cy: 6.66666667,
    r: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 5.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "5.33333333 0.123994963 5.33333333 3.55555556 0 3.55555556 0 0.123994963 2.67401286 1.51893829"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.235078053 0 5.09825528 0 2.67401286 1.27094837"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailButton);
export default __webpack_public_path__ + "static/media/EmailButton.c094c8849934be932635cc9885128034.svg";
export { ForwardRef as ReactComponent };